"use strict";
let yamController = {
	init: function() {

	},
	events: {
		// obj:{}
	},
	classStatus: function (className) {
		if (1) {
			return true
		}
		return false;
	},
	eventsStatus: function (eventName) {
		if (1) {
			return true
		}
		return false;
	}
}
Object.defineProperty(yamController, 'script', {
	enumerable: false,
	set: function (hz) {
		yamController.events[hz.name] = hz;
	},
	get: function() {
		// console.log(yamController.events);
		for(let key in yamController.events) {
			yamController.events[key]();
			console.log(this.obj[key]);
		}
	}
});
module.exports = yamController;


// WEBPACK FOOTER //
// ./libs/yam-controller.js